const DEV = 'development';
const PROD = 'production';
const NODE_ENV = 'NODE_ENV';
const LOG_LEVEL = 'LOG_LEVEL';
const TW_ENV_TYPE = 'TW_ENV_TYPE';
const nodeEnv = process.env[NODE_ENV] || DEV;
const isEnvProduction = nodeEnv === PROD;
const isEnvDevelopment = nodeEnv === DEV;
const logLevel = process.env[LOG_LEVEL] || 'info';
const isEnvRuntimeProd = process.env[TW_ENV_TYPE] === 'prod';
const isE2E = Boolean(process.env.E2E_TEST);
const enableBundleAnalyze = process.env.ANALYZE_BUNDLE || 'false';
const ACCOUNT_API_LOCAL = isE2E
  ? 'http://localhost:3072'
  : 'http://localhost:3073';

const accountApiBase = process.env.ACCOUNT_API_URI || ACCOUNT_API_LOCAL;

const supportChatUIConfig = {
  buttonPosition: {
    bottom: 20,
  },
  displayButtonOnRender: true,
  colors: {
    primaryColor: '#1859F1',
    secondaryColor: '#051230',
    botMessageBackground: '#F5F6FA',
    agentMessageBackground: '#E8EEFE',
  },
};

const supportChatConfig = {
  prod: {
    uiConfig: supportChatUIConfig,
    init: {
      orgId: '00D4L000000iBHI',
      eswConfigDevName: 'Marketplace_Web',
      scrt2URL: 'https://treatwell2021.my.salesforce-scrt.com',
    },
    bootstrapJsSrc:
      'https://cdn1.treatwell.net/support-chat-assets/tw-one-chat.js',
  },
  sandbox: {
    uiConfig: supportChatUIConfig,
    init: {
      orgId: '00DQ1000008G9Ni',
      eswConfigDevName: 'Marketplace_Web',
      scrt2URL: 'https://treatwell2021--staging.sandbox.my.salesforce-scrt.com',
    },
    bootstrapJsSrc:
      'https://cdn1.treatwell.net.staging.twtest.io/support-chat-assets/tw-one-chat.js',
  },
};

const salesforceBotConfig = {
  prod: {
    init: {
      orgId: '00D4L000000iBHI',
      eswConfigDevName: 'TW_Marketplace_Chat_Web',
      siteUrl:
        'https://treatwell2021.my.site.com/ESWTWMarketplaceChatWe1712743691428',
      scrt2URL: 'https://treatwell2021.my.salesforce-scrt.com',
    },
    bootstrapJsSrc:
      'https://treatwell2021.my.site.com/ESWTWMarketplaceChatWe1712743691428/assets/js/bootstrap.min.js',
  },
  sandbox: {
    init: {
      orgId: '00DUE000000MNvd',
      eswConfigDevName: 'TW_Marketplace_Chat_Web',
      siteUrl:
        'https://treatwell2021--partial.sandbox.my.site.com/ESWTWMarketplaceChatWe1711466057369',
      scrt2URL: 'https://treatwell2021--partial.sandbox.my.salesforce-scrt.com',
    },
    bootstrapJsSrc:
      'https://treatwell2021--partial.sandbox.my.site.com/ESWTWMarketplaceChatWe1711466057369/assets/js/bootstrap.js',
  },
};

module.exports = {
  env: {
    isEnvDevelopment,
    isEnvProduction,
    isEnvRuntimeProd,
    isE2E,
    logLevel,
    enableBundleAnalyze: enableBundleAnalyze === 'true',
    hostname: process.env.HOSTNAME || 'local-no-host-name',
  },
  cachedRequests: {
    ttl: 3000 * 60,
  },
  api: {
    accountApiBase,
    accountApiServer: `${accountApiBase}/api/v1`,
    accountApiClient: '/account-api/api/v1',
    rainbowApiClient: '/api/v1',
    mpApiClient: '/api/v2',
  },
  url: {
    browse: '/places',
    giftCard: '/gift-card',
    legal: '/info/terms-of-use',
  },
  htmlFiles: {
    // prod are the actual files written to the `build` folder with `yarn build`
    prod: {
      account: 'index.account-ui.html',
      directBookings: 'index.direct-bookings.html',
      cancellation: 'index.cancellation.html',
      accountRecover: 'index.account-recover.html',
      auth: 'index.auth.html',
    },
    // dev are the 'virtual' paths as webpack-dev-middlware is in memory
    dev: {
      account: 'account-ui/index.html',
      directBookings: 'direct-bookings/index.html',
      cancellation: 'cancellation/index.html',
      accountRecover: 'account-recover/index.html',
      auth: 'auth/index.html',
    },
  },
  salesforceBotConfig,
  supportChatConfig,
};
